// ----------------------------------------------------------------------
// <copyright file="Izenda.MovableController.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//
//</copyright>
// ----------------------------------------------------------------------
!function () {
  var action = require('mobx').action;
  var extendObservable = require('mobx').extendObservable;
  var EventName = {
    Move : 'onMove',
    MoveStart : 'onMoveStart',
    MoveStop : 'onMoveStop'
  };

  function MovableController(
    top,
    left,
    width,
    height,
    topLeftBoundary,
    rightBottomBoundary
  ){
    this.width = width;
    this.height = height;
    this.topLeftBoundary = topLeftBoundary;
    this.rightBottomBoundary = rightBottomBoundary;

    extendObservable(this, {
      top: top,
      left: left,
      slackX: 0,
      slackY: 0
    });
  }

  MovableController.prototype.updateMaxBoundary = function (right, bottom) {
    this.rightBottomBoundary.maxBottom = bottom;
    this.rightBottomBoundary.maxRight = right;
  };

  MovableController.prototype.updatePosition = action(function (top, left, width, height) {
    this.top = top;
    this.left = left;
    this.width = width;
    this.height = height;
  });

  MovableController.prototype.moveHandler = action(function (eventName, dragData, movableCallback) {
    var newTop = this.top + dragData.deltaY;
    var newLeft = this.left + dragData.deltaX;

    if(eventName === EventName.Move
      && newTop === this.top
      && newLeft === this.left){
      return;
    }

    var finalPos = this.runConstraints(newTop, newLeft);
    if (this.top !== finalPos.top){
      this.top = finalPos.top;
    }
    if (this.left !== finalPos.left){
      this.left = finalPos.left;
    }

    movableCallback && movableCallback({
      top: finalPos.top,
      left: finalPos.left,
      width: this.width,
      height: this.height
    });
  });

  MovableController.prototype.runConstraints = action(function (top, left) {
    var oldTop = top;
    var oldLeft = left;
    var slackX = this.slackX;
    var slackY = this.slackY;

    if (this.topLeftBoundary) {
      top = Math.max(this.topLeftBoundary.minTop, top + slackY);
      left = Math.max(this.topLeftBoundary.minLeft, left + slackX);
    }
    if (this.rightBottomBoundary) {
      top = Math.min(this.rightBottomBoundary.maxBottom, top + this.height) - this.height;
      left = Math.min(this.rightBottomBoundary.maxRight, left + this.width) - this.width;
    }

    this.slackX += oldLeft - left;
    this.slackY += oldTop - top;

    return {
      top: top,
      left: left
    };
  });

  MovableController.EventName = EventName;

  module.exports = MovableController;
}();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.MovableController.js